var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.formatedDescription)}},[(_vm.descriptionToLong)?_c('router-link',{staticClass:"text-primary",attrs:{"to":_vm.to}},[_vm._v(_vm._s(_vm.$t('item.readOn')))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }